// -- -- -- -- -- -- -- -- -- -- --


(function ($) {


    $( document ).ready(function() {
//      console.log( "ready!" );


      function getCookieValue(cname) { 
          // cname is the cookie name (foo) which value you are after
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for(var i = 0; i < ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) == ' ') {
                  c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                  return c.substring(name.length, c.length);
              }
          }
          return "";
      }
  
  if(!$('a#download-pdf').attr('href') && $('body').hasClass('single-job')){
    $('#download-pdf').wrap('<span style="display:none;"></span>');
    $('#ws-form-1').wrap('<span style="display:none;"></span>');
    $('#site-footer').wrap('<span style="display:none;"></span>');
    $('form').wrap('<span style="display:none;"></span>');
    jobcontent =  [];
    $('#dreiso_job > div').each(function( index ) {
        jobcontent.push($(this).html());
    });
    //jobcontent = $.trim(jobcontent);
//    console.log(jobcontent);
    
    $.ajax({
            type: 'POST', 
            url: '/wp-content/themes/dreiso2023/gen_pdf.php',
            data: {
                val: jobcontent
            },
    
            success: function(data) {
//                console.log('done2');
                
                $('#download-pdf').unwrap();
                $('#ws-form-1').unwrap();
                $('#site-footer').unwrap();
                $('form').unwrap();
                
                $.get('/wp-content/themes/dreiso2023/download.php', function(data) {
                  $('#download-pdf').attr('href' , '/wp-content/themes/dreiso2023/pdfs/'+data+'');
//                   console.log(data);
                }, 'text');
            }   
    });
//    console.log('done'); 
  }
      
      
      
      
      
      
      
      
      if ($(window).width() > 992) {
        $('nav .container > .nav-item-searchtoggle').remove();
        $('nav .container > #js-headerbadge').remove();
      }

      if ($('body').hasClass('single-produkte')) {
        var ProdPrevImgWrapper = $('body.single-produkte .produkt-content .product-image-wrapper .product-image-wrapper-preview .product-image-wrapper-img').first().html();
        var ProdImgWrapper = $('body.single-produkte .produkt-content .product-image-wrapper .product-image-wrapper-main');
        ProdImgWrapper.append(ProdPrevImgWrapper);
        $('.container-fluid.product-detail-information .bg-img').css('background-image' , 'url("'+$(ProdPrevImgWrapper).attr('src')+'")');
        $('body.single-produkte .produkt-content .product-image-wrapper .product-image-wrapper-preview .product-image-wrapper-img').on( "click", function() {
          var NewImg = $(this).find('img').attr('src')
          ProdImgWrapper.find('img').attr('src' , NewImg);
        } );

        $('.produkt-content.produkt-content-chemie .versions-wrappper .version-item').on( "click", function() {
          $('html, body').animate({
              scrollTop: $("#chemiepaletten-content").offset().top
          }, 500);
          var version = $(this).data('version');
          var name = $(this).find('span').text();
          $('.product-sizes-wrapper .product-sizes').addClass('d-none');
          $('.product-characteristics-wrapper .product-characteristics').addClass('d-none');
          $('.container-fluid.product-detail-information').removeClass('hidden p-0');
          $('.product-sizes-wrapper .product-sizes#'+version).removeClass('d-none');
          $('.product-characteristics-wrapper .product-characteristics#'+version).removeClass('d-none');
//          console.log('#'+version);
          $('#version-item-name').text(name);
        } );

          setTimeout(function() { 
            setTimeout(function() {
              if ($('body.single-produkte .custom-product-request-wrapper').first().find('input.product-amount').val() >= 1) {
//                console.log($('body.single-produkte .custom-product-request-wrapper').first().find('input.product-amount').val());
                $('#wsf-1-field-26').click();
//                console.log('Add Click Done');
              }
            }, 100);
            var length = $('body.single-produkte .custom-product-request-wrapper').length;
//            console.log('Elmnt Count:'+length);
            if (length < 1) {
              var preselect = '';
              var preselect = $('body.single-produkte .custom-product-request-wrapper').first().addClass('currentTarget').find('select.product-select option:first-child').text();
//              console.log('PreSelect:'+preselect);
                setTimeout(function() {
                  //$('body.single-produkte .currentTarget').next().remove();
                  $('body.single-produkte .custom-product-request-wrapper').first().find('select.product-select').val(preselect).change();
//                  console.log('PreSelect Done:'+preselect);
                  //if ($('body.single-produkte .custom-product-request-wrapper').first().find('input.product-amount').val() >= 1) {
                  //  $('#wsf-1-field-26').click();
                  ////  console.log('Add Click Done');
                  //}
                }, 100); 
            }else{
              setTimeout(function() {
              $('body.single-produkte .custom-product-request-wrapper').not('.currentTarget').each(function( index ) {
                var prodamount = $(this).find('input.product-amount').val();
//                console.log('Elmnt Menge Count:'+prodamount);
                if (prodamount == 0) {
                  $(this).find('.row .btn.btn-primary').click();
                }
              }); 
              }, 125);
              $('#wsf-1-field-26').click();
              
              var length = $('body.single-produkte .custom-product-request-wrapper').length;
//              console.log('Elmnt Count AfterClick:'+length);
//              console.log('PreSelect Done:'+preselect);
              var preselect = '';
              var preselect = $('body.single-produkte .custom-product-request-wrapper:nth-child('+length+')').find('select.product-select option:first-child').text();
              var currentProd = []; 
              
              $('body.single-produkte .custom-product-request-wrapper select.product-select').each(function( index ) {
                 currentProd.push($(this).find('option:selected' ).text());
              });
              
//              console.log('Elmnt Count:'+length);
              
              $('body.single-produkte .custom-product-request-wrapper:nth-child('+length+')').addClass('currentTarget').find('select.product-select').val(preselect).change();
            } 


          }, 2000);

        $('.navbar-toggler').on( "click", function() {
          var search = $('.nav-item-searchtoggle');
          var bag = $('#js-headerbadge');
          $('body').toggleClass('overflow-hidden');
          $('nav').toggleClass('navbar-open');
          $('.navbar-brand').toggleClass('d-none');
          $('nav svg#opener').toggleClass('d-none');
          $('nav svg#closer').toggleClass('d-block');
          if ($('nav svg#closer').hasClass('d-none')) {
            $('nav svg#closer').addClass('d-block');
            $('nav svg#closer').removeClass('d-none');
          }else{
            $('nav svg#closer').removeClass('d-block');
            $('nav svg#closer').addClass('d-none');
          }
          //$('.navbar-toggler').toggleClass('ms-4');
          //if ($('nav .container > .nav-item-searchtoggle').length) {
          //  $('nav .container > .nav-item-searchtoggle').remove();
          //  $('nav .container > ##js-headerbadge').remove();
          //  $('nav .container').prepend(bag);
          //  $('nav .container').prepend(search);
          //}
        });
      }

    });


/*!
 * Lightbox v2.11.4
 * by Lokesh Dhakar
 *
 * More info:
 * http://lokeshdhakar.com/projects/lightbox2/
 *
 * Copyright Lokesh Dhakar
 * Released under the MIT license
 * https://github.com/lokesh/lightbox2/blob/master/LICENSE
 *
 * @preserve
 */ !function(t,i){"function"==typeof define&&define.amd?define(["jquery"],i):"object"==typeof exports?module.exports=i(require("jquery")):t.lightbox=i(t.jQuery)}(this,function(t){function i(i){this.album=[],this.currentImageIndex=void 0,this.init(),this.options=t.extend({},this.constructor.defaults),this.option(i)}return i.defaults={albumLabel:"Image %1 of %2",alwaysShowNavOnTouchDevices:!1,fadeDuration:600,fitImagesInViewport:!0,imageFadeDuration:600,positionFromTop:50,resizeDuration:700,showImageNumberLabel:!0,wrapAround:!1,disableScrolling:!1,sanitizeTitle:!1},i.prototype.option=function(i){t.extend(this.options,i)},i.prototype.imageCountLabel=function(t,i){return this.options.albumLabel.replace(/%1/g,t).replace(/%2/g,i)},i.prototype.init=function(){var i=this;t(document).ready(function(){i.enable(),i.build()})},i.prototype.enable=function(){var i=this;t("body").on("click","a[rel^=lightbox], area[rel^=lightbox], a[data-lightbox], area[data-lightbox]",function(e){return i.start(t(e.currentTarget)),!1})},i.prototype.build=function(){if(!(t("#lightbox").length>0)){var i=this;t('<div id="lightboxOverlay" tabindex="-1" class="lightboxOverlay"></div><div id="lightbox" tabindex="-1" class="lightbox"><div class="lb-outerContainer"><div class="lb-container"><img class="lb-image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt=""/><div class="lb-nav"><a class="lb-prev" role="button" tabindex="0" aria-label="Previous image" href="" ></a><a class="lb-next" role="button" tabindex="0" aria-label="Next image" href="" ></a></div><div class="lb-loader"><a class="lb-cancel" role="button" tabindex="0"></a></div></div></div><div class="lb-dataContainer"><div class="lb-data"><div class="lb-details"><span class="lb-caption"></span><span class="lb-number"></span></div><div class="lb-closeContainer"><a class="lb-close" role="button" tabindex="0"></a></div></div></div></div>').appendTo(t("body")),this.$lightbox=t("#lightbox"),this.$overlay=t("#lightboxOverlay"),this.$outerContainer=this.$lightbox.find(".lb-outerContainer"),this.$container=this.$lightbox.find(".lb-container"),this.$image=this.$lightbox.find(".lb-image"),this.$nav=this.$lightbox.find(".lb-nav"),this.containerPadding={top:parseInt(this.$container.css("padding-top"),10),right:parseInt(this.$container.css("padding-right"),10),bottom:parseInt(this.$container.css("padding-bottom"),10),left:parseInt(this.$container.css("padding-left"),10)},this.imageBorderWidth={top:parseInt(this.$image.css("border-top-width"),10),right:parseInt(this.$image.css("border-right-width"),10),bottom:parseInt(this.$image.css("border-bottom-width"),10),left:parseInt(this.$image.css("border-left-width"),10)},this.$overlay.hide().on("click",function(){return i.end(),!1}),this.$lightbox.hide().on("click",function(e){"lightbox"===t(e.target).attr("id")&&i.end()}),this.$outerContainer.on("click",function(e){return"lightbox"===t(e.target).attr("id")&&i.end(),!1}),this.$lightbox.find(".lb-prev").on("click",function(){return 0===i.currentImageIndex?i.changeImage(i.album.length-1):i.changeImage(i.currentImageIndex-1),!1}),this.$lightbox.find(".lb-next").on("click",function(){return i.currentImageIndex===i.album.length-1?i.changeImage(0):i.changeImage(i.currentImageIndex+1),!1}),this.$nav.on("mousedown",function(t){3===t.which&&(i.$nav.css("pointer-events","none"),i.$lightbox.one("contextmenu",function(){setTimeout((function(){this.$nav.css("pointer-events","auto")}).bind(i),0)}))}),this.$lightbox.find(".lb-loader, .lb-close").on("click keyup",function(t){if("click"===t.type||"keyup"===t.type&&(13===t.which||32===t.which))return i.end(),!1})}},i.prototype.start=function(i){var e,n=this,o=t(window);o.on("resize",t.proxy(this.sizeOverlay,this)),this.sizeOverlay(),this.album=[];var a=0;function h(t){n.album.push({alt:t.attr("data-alt"),link:t.attr("href"),title:t.attr("data-title")||t.attr("title")})}var s=i.attr("data-lightbox");if(s){e=t(i.prop("tagName")+'[data-lightbox="'+s+'"]');for(var r=0;r<e.length;r=++r)h(t(e[r])),e[r]===i[0]&&(a=r)}else if("lightbox"===i.attr("rel"))h(i);else{e=t(i.prop("tagName")+'[rel="'+i.attr("rel")+'"]');for(var l=0;l<e.length;l=++l)h(t(e[l])),e[l]===i[0]&&(a=l)}var d=o.scrollTop()+this.options.positionFromTop,g=o.scrollLeft();this.$lightbox.css({top:d+"px",left:g+"px"}).fadeIn(this.options.fadeDuration),this.options.disableScrolling&&t("body").addClass("lb-disable-scrolling"),this.changeImage(a)},i.prototype.changeImage=function(i){var e=this,n=this.album[i].link,o=n.split(".").slice(-1)[0],a=this.$lightbox.find(".lb-image");this.disableKeyboardNav(),this.$overlay.fadeIn(this.options.fadeDuration),t(".lb-loader").fadeIn("slow"),this.$lightbox.find(".lb-image, .lb-nav, .lb-prev, .lb-next, .lb-dataContainer, .lb-numbers, .lb-caption").hide(),this.$outerContainer.addClass("animating");var h=new Image;h.onload=function(){a.attr({alt:e.album[i].alt,src:n}),s=t(h),a.width(h.width),a.height(h.height);var s,r,l,d,g,b,c,u=h.width/h.height;c=t(window).width(),b=t(window).height(),g=c-e.containerPadding.left-e.containerPadding.right-e.imageBorderWidth.left-e.imageBorderWidth.right-20,d=b-e.containerPadding.top-e.containerPadding.bottom-e.imageBorderWidth.top-e.imageBorderWidth.bottom-e.options.positionFromTop-70,"svg"===o?(u>=1?(l=g,r=parseInt(g/u,10)):(l=parseInt(d/u,10),r=d),a.width(l),a.height(r)):(e.options.fitImagesInViewport?(e.options.maxWidth&&e.options.maxWidth<g&&(g=e.options.maxWidth),e.options.maxHeight&&e.options.maxHeight<d&&(d=e.options.maxHeight)):(g=e.options.maxWidth||h.width||g,d=e.options.maxHeight||h.height||d),(h.width>g||h.height>d)&&(h.width/g>h.height/d?(l=g,r=parseInt(h.height/(h.width/l),10),a.width(l),a.height(r)):(r=d,l=parseInt(h.width/(h.height/r),10),a.width(l),a.height(r)))),e.sizeContainer(a.width(),a.height())},h.src=this.album[i].link,this.currentImageIndex=i},i.prototype.sizeOverlay=function(){var i=this;setTimeout(function(){i.$overlay.width(t(document).width()).height(t(document).height())},0)},i.prototype.sizeContainer=function(t,i){var e=this,n=this.$outerContainer.outerWidth(),o=this.$outerContainer.outerHeight(),a=t+this.containerPadding.left+this.containerPadding.right+this.imageBorderWidth.left+this.imageBorderWidth.right,h=i+this.containerPadding.top+this.containerPadding.bottom+this.imageBorderWidth.top+this.imageBorderWidth.bottom;function s(){e.$lightbox.find(".lb-dataContainer").width(a),e.$lightbox.find(".lb-prevLink").height(h),e.$lightbox.find(".lb-nextLink").height(h),e.$overlay.trigger("focus"),e.showImage()}n!==a||o!==h?this.$outerContainer.animate({width:a,height:h},this.options.resizeDuration,"swing",function(){s()}):s()},i.prototype.showImage=function(){this.$lightbox.find(".lb-loader").stop(!0).hide(),this.$lightbox.find(".lb-image").fadeIn(this.options.imageFadeDuration),this.updateNav(),this.updateDetails(),this.preloadNeighboringImages(),this.enableKeyboardNav()},i.prototype.updateNav=function(){var t=!1;try{document.createEvent("TouchEvent"),t=!!this.options.alwaysShowNavOnTouchDevices}catch(i){}this.$lightbox.find(".lb-nav").show(),this.album.length>1&&(this.options.wrapAround?(t&&this.$lightbox.find(".lb-prev, .lb-next").css("opacity","1"),this.$lightbox.find(".lb-prev, .lb-next").show()):(this.currentImageIndex>0&&(this.$lightbox.find(".lb-prev").show(),t&&this.$lightbox.find(".lb-prev").css("opacity","1")),this.currentImageIndex<this.album.length-1&&(this.$lightbox.find(".lb-next").show(),t&&this.$lightbox.find(".lb-next").css("opacity","1"))))},i.prototype.updateDetails=function(){var t=this;if(void 0!==this.album[this.currentImageIndex].title&&""!==this.album[this.currentImageIndex].title){var i=this.$lightbox.find(".lb-caption");this.options.sanitizeTitle?i.text(this.album[this.currentImageIndex].title):i.html(this.album[this.currentImageIndex].title),i.fadeIn("fast")}if(this.album.length>1&&this.options.showImageNumberLabel){var e=this.imageCountLabel(this.currentImageIndex+1,this.album.length);this.$lightbox.find(".lb-number").text(e).fadeIn("fast")}else this.$lightbox.find(".lb-number").hide();this.$outerContainer.removeClass("animating"),this.$lightbox.find(".lb-dataContainer").fadeIn(this.options.resizeDuration,function(){return t.sizeOverlay()})},i.prototype.preloadNeighboringImages=function(){this.album.length>this.currentImageIndex+1&&(new Image().src=this.album[this.currentImageIndex+1].link),this.currentImageIndex>0&&(new Image().src=this.album[this.currentImageIndex-1].link)},i.prototype.enableKeyboardNav=function(){this.$lightbox.on("keyup.keyboard",t.proxy(this.keyboardAction,this)),this.$overlay.on("keyup.keyboard",t.proxy(this.keyboardAction,this))},i.prototype.disableKeyboardNav=function(){this.$lightbox.off(".keyboard"),this.$overlay.off(".keyboard")},i.prototype.keyboardAction=function(t){var i=t.keyCode;27===i?(t.stopPropagation(),this.end()):37===i?0!==this.currentImageIndex?this.changeImage(this.currentImageIndex-1):this.options.wrapAround&&this.album.length>1&&this.changeImage(this.album.length-1):39===i&&(this.currentImageIndex!==this.album.length-1?this.changeImage(this.currentImageIndex+1):this.options.wrapAround&&this.album.length>1&&this.changeImage(0))},i.prototype.end=function(){this.disableKeyboardNav(),t(window).off("resize",this.sizeOverlay),this.$lightbox.fadeOut(this.options.fadeDuration),this.$overlay.fadeOut(this.options.fadeDuration),this.options.disableScrolling&&t("body").removeClass("lb-disable-scrolling")},new i});
})(jQuery);


/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2006, 2014 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD (Register as an anonymous module)
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node/CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {

    var pluses = /\+/g;

    function encode(s) {
        return config.raw ? s : encodeURIComponent(s);
    }

    function decode(s) {
        return config.raw ? s : decodeURIComponent(s);
    }

    function stringifyCookieValue(value) {
        return encode(config.json ? JSON.stringify(value) : String(value));
    }

    function parseCookieValue(s) {
        if (s.indexOf('"') === 0) {
            // This is a quoted cookie as according to RFC2068, unescape...
            s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
        }

        try {
            // Replace server-side written pluses with spaces.
            // If we can't decode the cookie, ignore it, it's unusable.
            // If we can't parse the cookie, ignore it, it's unusable.
            s = decodeURIComponent(s.replace(pluses, ' '));
            return config.json ? JSON.parse(s) : s;
        } catch(e) {}
    }

    function read(s, converter) {
        var value = config.raw ? s : parseCookieValue(s);
        return $.isFunction(converter) ? converter(value) : value;
    }

    var config = $.cookie = function (key, value, options) {

        // Write

        if (arguments.length > 1 && !$.isFunction(value)) {
            options = $.extend({}, config.defaults, options);

            if (typeof options.expires === 'number') {
                var days = options.expires, t = options.expires = new Date();
                t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
            }

            return (document.cookie = [
                encode(key), '=', stringifyCookieValue(value),
                options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                options.path    ? '; path=' + options.path : '',
                options.domain  ? '; domain=' + options.domain : '',
                options.secure  ? '; secure' : ''
            ].join(''));
        }

        // Read

        var result = key ? undefined : {},
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all. Also prevents odd result when
            // calling $.cookie().
            cookies = document.cookie ? document.cookie.split('; ') : [],
            i = 0,
            l = cookies.length;

        for (; i < l; i++) {
            var parts = cookies[i].split('='),
                name = decode(parts.shift()),
                cookie = parts.join('=');

            if (key === name) {
                // If second argument (value) is a function it's a converter...
                result = read(cookie, value);
                break;
            }

            // Prevent storing a cookie that we couldn't decode.
            if (!key && (cookie = read(cookie)) !== undefined) {
                result[name] = cookie;
            }
        }

        return result;
    };

    config.defaults = {};

    $.removeCookie = function (key, options) {
        // Must not alter options, thus extending a fresh object...
        $.cookie(key, '', $.extend({}, options, { expires: -1 }));
        return !$.cookie(key);
    };

}));

/*! jquery.cookie v1.4.1 | MIT */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?a(require("jquery")):a(jQuery)}(function(a){function b(a){return h.raw?a:encodeURIComponent(a)}function c(a){return h.raw?a:decodeURIComponent(a)}function d(a){return b(h.json?JSON.stringify(a):String(a))}function e(a){0===a.indexOf('"')&&(a=a.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return a=decodeURIComponent(a.replace(g," ")),h.json?JSON.parse(a):a}catch(b){}}function f(b,c){var d=h.raw?b:e(b);return a.isFunction(c)?c(d):d}var g=/\+/g,h=a.cookie=function(e,g,i){if(void 0!==g&&!a.isFunction(g)){if(i=a.extend({},h.defaults,i),"number"==typeof i.expires){var j=i.expires,k=i.expires=new Date;k.setTime(+k+864e5*j)}return document.cookie=[b(e),"=",d(g),i.expires?"; expires="+i.expires.toUTCString():"",i.path?"; path="+i.path:"",i.domain?"; domain="+i.domain:"",i.secure?"; secure":""].join("")}for(var l=e?void 0:{},m=document.cookie?document.cookie.split("; "):[],n=0,o=m.length;o>n;n++){var p=m[n].split("="),q=c(p.shift()),r=p.join("=");if(e&&e===q){l=f(r,g);break}e||void 0===(r=f(r))||(l[q]=r)}return l};h.defaults={},a.removeCookie=function(b,c){return void 0===a.cookie(b)?!1:(a.cookie(b,"",a.extend({},c,{expires:-1})),!a.cookie(b))}});